<template>
  <div>
    <div v-if="activeRoute">
      <div v-if="!disabled">
        <div class="d-flex justify-space-between ga-3 align-center mb-3">
          <div class="font-size-15">
            <span class="font-weight-bold mr-1">Етапи маршруту</span>
            <span class="text-disabled"
              >({{ activeRoute.stages?.length ?? 0 }})</span
            >
          </div>

          <v-btn color="light-blue-darken-4" @click="stageCreate">
            <v-icon class="mr-2" icon="mdi-plus"></v-icon>
            <span>Додати етап</span>
          </v-btn>
        </div>

        <route-stages
          v-if="activeRoute.stages?.length"
          :readonly-participants="activeRoute.typeId === 1 || disabled"
          :readonly-stages="[1, 4].includes(activeRoute.typeId) || disabled"
          :stages="activeRoute.stages"
          @stage-update="stageUpdate"
          @stage-delete="stageDelete($event)"
          @participant-create="
            stageParticipantCreate($event.stageId, $event.userId)
          "
          @participant-delete="
            stageParticipantDelete($event.stageId, $event.participantId)
          "></route-stages>

        <empty-section
          v-else
          description="Додайте перший етап маршруту, щоб запустити погодження документа"
          title="Маршрут погодження ще порожній"></empty-section>
      </div>

      <route-tracker v-else></route-tracker>
    </div>

    <empty-section
      v-else
      description="Для цього типу документа ще не налаштовано активний маршрут"
      title="Маршрут погодження відсутній"></empty-section>
  </div>
</template>

<script lang="ts" setup>
import EmptySection from '@/components/EmptySection.vue'
import RouteStages from '@/components/doc-type-routes/RouteStages.vue'
import RouteTracker from './RouteTracker.vue'
import { useDocument } from '../../document'

defineOptions({
  name: 'Routes',
})

const {
  disabled,
  activeRoute,
  stageCreate,
  stageUpdate,
  stageDelete,
  stageParticipantCreate,
  stageParticipantDelete,
} = useDocument()
</script>
